(function () {
  'use strict';

  var API_ROOT = 'https://judge.me/api/v1/widgets/product_review';
  var instances = new WeakMap();

  function clampRating(value) {
    return Math.max(0, Math.min(5, Number(value) || 0));
  }

  function safeUrl(value) {
    if (!value || typeof value !== 'string') {
      return '';
    }

    try {
      var url = new URL(value, window.location.origin);
      return /^https?:$/.test(url.protocol) ? url.href : '';
    } catch (error) {
      return '';
    }
  }

  // Keep Judge.me-specific field names in this function only.
  function normalizeReview(source, reviewElement) {
    var item = source || {};

    if (reviewElement) {
      var verifiedMarker = reviewElement.querySelector(
        '.jdgm-rev__icon--verified, [data-verified="true"]'
      );

      item = {
        uuid: reviewElement.getAttribute('data-uuid') || '',
        rating: reviewElement.getAttribute('data-score') || '',
        author: (reviewElement.querySelector(
          '[data-rev-author], .jdgm-rev__author'
        ) || {}).textContent || '',
        body: (reviewElement.querySelector(
          '[data-content], .jdgm-rev__body'
        ) || {}).textContent || '',
        title: (reviewElement.querySelector(
          '[data-review-title], .jdgm-rev__title'
        ) || {}).textContent || '',
        pictures: Array.prototype.map.call(
          reviewElement.querySelectorAll('img'),
          function (image) {
            return { url: image.currentSrc || image.src };
          }
        ),
        verified_buyer: Boolean(verifiedMarker)
      };
    }

    var pictures = item.pictures || item.images || item.picture_urls || [];
    var videoValues = item.video_urls || item.videos || [];
    var videoIds = item.video_external_ids || item.video_ids || [];

    if (!Array.isArray(pictures)) pictures = [];
    if (!Array.isArray(videoValues)) videoValues = [];
    if (!Array.isArray(videoIds)) videoIds = [];

    var images = pictures
      .map(function (picture) {
        return safeUrl(
          typeof picture === 'string'
            ? picture
            : picture.url || picture.src || picture.original_url
        );
      })
      .filter(Boolean);

    var videos = videoValues
      .map(function (video) {
        return safeUrl(typeof video === 'string' ? video : video.url || video.src);
      })
      .filter(Boolean);

    return {
      id: String(item.uuid || item.id || item.review_id || Math.random()),
      rating: clampRating(item.rating || item.score),
      author: String(item.author || item.reviewer_name || item.name || '').trim(),
      body: String(item.body || item.content || '').trim(),
      title: String(item.title || '').trim(),
      images: images,
      videos: videos,
      verified:
        item.verified_buyer === true ||
        item.verified_buyer === 'true' ||
        item.verified === true,
      hasMedia: Boolean(
        images.length ||
          videos.length ||
          videoIds.length ||
          item.has_published_pictures ||
          item.has_published_videos
      )
    };
  }

  function parseResponse(data) {
    if (Array.isArray(data.reviews)) {
      return data.reviews.map(function (review) {
        return normalizeReview(review);
      });
    }

    if (typeof data.widget === 'string') {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = data.widget;

      return Array.prototype.map.call(
        wrapper.querySelectorAll('.jdgm-rev'),
        function (reviewElement) {
          return normalizeReview({}, reviewElement);
        }
      );
    }

    return [];
  }

  function createStars(rating) {
    var displayedRating = Math.ceil(rating);
    var stars = document.createElement('span');
    stars.className = 'kushae-ratings-reviews__stars';
    stars.setAttribute('aria-hidden', 'true');

    for (var index = 1; index <= 5; index += 1) {
      var star = document.createElement('span');
      star.className =
        'kushae-ratings-reviews__star-glyph' +
        (displayedRating >= index ? ' is-filled' : '');
      star.textContent = displayedRating >= index ? '★' : '☆';
      stars.appendChild(star);
    }

    return stars;
  }

  function renderReview(review) {
    var article = document.createElement('article');
    article.className = 'kushae-ratings-reviews__review';

    var ratingRow = document.createElement('div');
    ratingRow.className = 'kushae-ratings-reviews__rating-row';
    ratingRow.appendChild(createStars(review.rating));

    var ratingText = document.createElement('span');
    ratingText.className = 'kushae-ratings-reviews__rating-text';
    ratingText.textContent = Math.ceil(review.rating) + ' Stars';
    ratingRow.appendChild(ratingText);
    article.appendChild(ratingRow);

    var author = document.createElement('h3');
    author.className = 'kushae-ratings-reviews__author';
    author.textContent = review.author || 'Customer';
    article.appendChild(author);

    var body = document.createElement('p');
    body.className = 'kushae-ratings-reviews__body';
    body.textContent = review.body;
    article.appendChild(body);

    if (review.images.length || review.videos.length) {
      var media = document.createElement('div');
      media.className = 'kushae-ratings-reviews__media';

      review.images.forEach(function (url) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'kushae-ratings-reviews__media-item';
        button.setAttribute('aria-label', 'Open review image');

        var image = document.createElement('img');
        image.src = url;
        image.alt = '';
        image.loading = 'lazy';
        button.appendChild(image);
        media.appendChild(button);
      });

      review.videos.forEach(function (url) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'kushae-ratings-reviews__media-item';
        button.setAttribute('aria-label', 'Play review video');

        var video = document.createElement('video');
        video.src = url;
        video.controls = true;
        video.preload = 'metadata';
        button.appendChild(video);
        media.appendChild(button);
      });

      article.appendChild(media);
    }

    return article;
  }

  function init(section) {
    if (!section || instances.has(section)) return;

    var state = {
      allReviews: [],
      page: 1,
      rating: 'all',
      perPage: Math.max(
        1,
        Math.min(20, Number(section.dataset.reviewsPerPage) || 5)
      )
    };

    instances.set(section, state);

    var list = section.querySelector('[data-kushae-list]');
    var status = section.querySelector('[data-kushae-status]');
    var pagination = section.querySelector('[data-kushae-pagination]');
    var results = section.querySelector('[data-kushae-results]');

    function filteredReviews() {
      return state.allReviews.filter(function (review) {
        return (
          state.rating === 'all' ||
          Math.ceil(review.rating) === Number(state.rating)
        );
      });
    }

    function renderPagination(pageCount) {
      pagination.replaceChildren();

      if (pageCount <= 1) return;

      var firstPage = Math.max(
        1,
        Math.min(state.page - 1, pageCount - 2)
      );
      var lastPage = Math.min(pageCount, firstPage + 2);

      for (var page = firstPage; page <= lastPage; page += 1) {
        (function (pageNumber) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className =
            'kushae-ratings-reviews__page' +
            (pageNumber === state.page ? ' is-active' : '');
          button.textContent = pageNumber;
          button.setAttribute('aria-label', 'Page ' + pageNumber);

          if (pageNumber === state.page) {
            button.disabled = true;
            button.setAttribute('aria-current', 'page');
          }

          button.addEventListener('click', function () {
            state.page = pageNumber;
            render();
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });

          pagination.appendChild(button);
        })(page);
      }

      if (state.page < pageCount) {
        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'kushae-ratings-reviews__page';
        next.textContent = '›';
        next.setAttribute('aria-label', 'Next page');
        next.addEventListener('click', function () {
          state.page += 1;
          render();
        });
        pagination.appendChild(next);

        var last = document.createElement('button');
        last.type = 'button';
        last.className = 'kushae-ratings-reviews__page';
        last.textContent = '»';
        last.setAttribute('aria-label', 'Last page');
        last.addEventListener('click', function () {
          state.page = pageCount;
          render();
        });
        pagination.appendChild(last);
      }
    }

    function render() {
      var reviews = filteredReviews();
      var pageCount = Math.ceil(reviews.length / state.perPage);
      state.page = Math.min(state.page, Math.max(1, pageCount));

      list.replaceChildren();

      if (!reviews.length) {
        status.textContent = state.allReviews.length
          ? 'No reviews match the selected filters.'
          : 'No verified reviews yet.';
      } else {
        status.textContent = '';
        reviews
          .slice(
            (state.page - 1) * state.perPage,
            state.page * state.perPage
          )
          .forEach(function (review) {
            list.appendChild(renderReview(review));
          });
      }

      renderPagination(pageCount);
    }

    function fetchPage(page, filterRating) {
      var url = new URL(API_ROOT);
      url.searchParams.set('shop_domain', section.dataset.shopDomain);
      url.searchParams.set('api_token', section.dataset.publicApiToken);
      url.searchParams.set('handle', section.dataset.productHandle);
      url.searchParams.set('external_id', section.dataset.productId);
      url.searchParams.set('per_page', '100');
      url.searchParams.set('page', String(page));
      url.searchParams.set('json_request', 'true');

      if (filterRating !== 'all') {
        url.searchParams.set('filter_rating', filterRating);
      }

      return fetch(url.toString(), {
        credentials: 'omit',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Judge.me request failed');
        return response.json();
      });
    }

    function load(filterRating) {
      var token = section.dataset.publicApiToken;

      if (!token) {
        status.textContent = 'Reviews are currently unavailable.';
        results.setAttribute('aria-busy', 'false');
        return;
      }

      results.setAttribute('aria-busy', 'true');
      status.textContent = 'Loading reviews…';

      fetchPage(1, filterRating)
        .then(function (firstData) {
          var pageCount = Math.max(
            1,
            Number(firstData.total_pages) || 1
          );
          var requests = [];

          for (var page = 2; page <= pageCount; page += 1) {
            requests.push(fetchPage(page, filterRating));
          }

          return Promise.all(requests).then(function (rest) {
            return [firstData].concat(rest);
          });
        })
        .then(function (responses) {
          state.allReviews = responses
            .reduce(function (reviews, data) {
              return reviews.concat(parseResponse(data));
            }, [])
            .filter(function (review) {
              return review.body && review.rating >= 1 && review.verified;
            });

          render();
          results.setAttribute('aria-busy', 'false');
        })
        .catch(function () {
          status.textContent = 'Reviews are currently unavailable.';
          results.setAttribute('aria-busy', 'false');
        });
    }

    section
      .querySelector('[data-kushae-rating-filter]')
      .addEventListener('change', function (event) {
        state.rating = event.target.value;
        state.page = 1;
        load(state.rating);
      });

    load('all');
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('[data-kushae-ratings-reviews]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
